import { useState, useEffect } from "react";

const useNotificationPermission = () => {
  const [permission, setPermission] = useState(Notification.permission);

  useEffect(() => {
    if (Notification.permission === "default") {
      Notification.requestPermission().then((status) => setPermission(status));
    } else {
      setPermission(Notification.permission);
    }
  }, []);

  return permission;
};

export default useNotificationPermission;